export default __webpack_public_path__ + "static/media/uploader-abbottXtra-3.cd64cc5b.png";